export class ErrorSummary {
    message: string;
    moreDetails?: string;
    constructor(message: string, moreDetails?: string) {
        this.message = message;
        this.moreDetails = moreDetails;
    }
}